import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import AdminApplicationFiles from './AdminApplicationFiles';
import AdminStorageStats from './AdminStorageStats';

// Component to wrap the application file management with applicationId from URL
const ApplicationFilesWrapper: React.FC = () => {
  const { applicationId } = useParams<{ applicationId: string }>();
  return <AdminApplicationFiles applicationId={applicationId} />;
};

// Component to handle routes for admin file management
const AdminFileRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="storage-stats" element={<AdminStorageStats />} />
      <Route path="applications/:applicationId/files" element={<ApplicationFilesWrapper />} />
      <Route path="applications" element={<AdminApplicationFiles />} />
      <Route index element={<AdminApplicationFiles />} />
    </Routes>
  );
};

export default AdminFileRoutes;
